import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { noop } from 'Helpers/PropTypes';
import { HistoryOutlined } from '@material-ui/icons';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { useRightSidebarContext } from 'Views/Page/Content/RightSidebar/RightSidebarContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import categories from 'EventTracking/consts/categories';
import eventTypes from 'EventTracking/consts/eventTypes';
import AddInsightsButtonPicker
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentDefault/LeftSide/TabsPicker/Tabs/TabContentPicker/TabContent/Content/TabLayouts/Insights/Default/ProposalScenarioInsights/AddInsightsButton';
import InsightFormPicker from './InsightForm';

const styles = theme => ({
  root: {},
  group: {},
  alert: {
    margin: theme.spacing(3, 3, 0, 3),
  },
  titleBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonContainer: {
    display: 'flex',
  },
});

const ProposalScenarioInsights = ({
  className, classes, onSubmit,
}) => {
  const { resource } = useMetaLayoutContext();
  const { loadRightSidebarCollectionLink } = useRightSidebarContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handleHistoryOnClick = async () => {
    logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'proposal insight history open button');
    loadRightSidebarCollectionLink(resource.relationship('history').link('related'));
  };

  return (
    <Box className={classNames(classes.root, className)}>
      <Box className={classes.titleBar}>
        <Text
          align="left"
          noWrap
          text={resource.attr(
            'scenarioTitle',
          )}
          title={resource.attr(
            'scenarioTitle',
          )}
          variant="h3"
          weight="medium"
        />
        <Box className={classes.buttonContainer}>
          <IconButton
            onClick={handleHistoryOnClick}
            color={'primary'}
            icon={HistoryOutlined}
            title={'History'}
            test={'facet-plan-insight-history-button'}
          />
          <AddInsightsButtonPicker
            resource={resource}
          />
        </Box>
      </Box>
      <InsightFormPicker onSubmit={onSubmit} />
    </Box>
  );
};

ProposalScenarioInsights.defaultProps = {
  className: '',
  onSubmit: noop,
};

ProposalScenarioInsights.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
};

export default withStyles(styles)(ProposalScenarioInsights);
